import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authFetch } from '../utils/authFetch';
import Spinner from './Spinner';

const ConstructorForm = ({ usuario }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const isEditing = Boolean(id);

    const [formData, setFormData] = useState({
        nombre: '',
        descripcion: '',
        direccion: '',
        telefono: '',
        email: '',
        coste_mano_obra_hora: '',
        public: false,
    });
    const [loading, setLoading] = useState(isEditing);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isEditing) {
            setLoading(false);
            return;
        }

        const fetchConstructorData = async () => {
            try {
                const constructorData = await authFetch(`${window.REACT_APP_API_ENDPOINT}/api/constructores/${id}`);
                setFormData({
                    nombre: constructorData.nombre || '',
                    descripcion: constructorData.descripcion || '',
                    direccion: constructorData.direccion || '',
                    telefono: constructorData.telefono || '',
                    email: constructorData.email || '',
                    coste_mano_obra_hora: constructorData.coste_mano_obra_hora || '',
                    public: constructorData.public || false,
                });
            } catch (err) {
                setError('Error al cargar los datos del constructor.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchConstructorData();
    }, [id, isEditing]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const url = isEditing
            ? `${window.REACT_APP_API_ENDPOINT}/api/constructores/${id}`
            : `${window.REACT_APP_API_ENDPOINT}/api/constructores`;
        const method = isEditing ? 'PUT' : 'POST';

        try {
            await authFetch(url, {
                method,
                body: JSON.stringify(formData),
            });
            navigate('/constructores');
        } catch (err) {
            setError('Error al guardar el constructor. Por favor, revise los datos.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Spinner text="Cargando formulario..." />;
    if (error) return <div className="text-red-500 text-center p-4">{error}</div>;

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6">{isEditing ? 'Editar Constructor' : 'Nuevo Constructor'}</h1>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Form Fields */}
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombre">
                            Nombre <span className="text-red-500">*</span>
                        </label>
                        <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" required />
                    </div>
                     <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="coste_mano_obra_hora">
                            Coste Mano de Obra (€/hora) <span className="text-red-500">*</span>
                        </label>
                        <input type="number" step="0.01" name="coste_mano_obra_hora" value={formData.coste_mano_obra_hora} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" required />
                    </div>
                     <div className="mb-4 md:col-span-2">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="descripcion">Descripción</label>
                        <textarea name="descripcion" value={formData.descripcion} onChange={handleChange} rows="3" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                    </div>
                     <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                     <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="telefono">Teléfono</label>
                        <input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                    <div className="mb-4 md:col-span-2">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="direccion">Dirección</label>
                        <input type="text" name="direccion" value={formData.direccion} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                    {usuario?.rol === 'admin' && (
                        <div className="mb-4 flex items-center">
                            <input type="checkbox" name="public" checked={formData.public} onChange={handleChange} className="mr-2 leading-tight" />
                            <label className="text-gray-700 text-sm font-bold" htmlFor="public">Público (accesible para todos)</label>
                        </div>
                    )}
                </div>

                <div className="flex items-center justify-end mt-8">
                    <button type="button" onClick={() => navigate('/constructores')} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 mr-2">
                        Cancelar
                    </button>
                    <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" disabled={loading}>
                        {loading ? 'Guardando...' : 'Guardar'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ConstructorForm; 